<template>
  <div>
    <div v-if="items" class="w-full">
      <div class="mx-auto max-w-4xl">
        <h2 class="font-semibold tracking-tight text-xl" :class="[$theme.baseTextColor]">
          {{ $t('frequently_asked_questions') }}
        </h2>
        <dl class="mt-2">
          <Disclosure as="div" v-for="(item, i) in items" :key="item.id" class="pt-3 pb-3 m-light-card-border-color" v-slot="{ open }" :class="[
                    $theme.baseTextColor,
                    i !== 0 ? 'border-t' : ''
                  ]">
            <dt>
              <DisclosureButton class="flex w-full items-start justify-between font-medium text-left text-base">
                <span>{{ item.question }}</span>
                <span class="ml-6 flex h-7 items-center m-blue-color">
                  <PlusSmallIcon v-if="!open" class="h-6 w-6" :class="[$theme.IconTextColor]" aria-hidden="true" />
                  <MinusSmallIcon v-else class="h-6 w-6" :class="[$theme.IconTextColor]" aria-hidden="true" />
                </span>
              </DisclosureButton>
            </dt>
            <DisclosurePanel as="dd" class="mt-2 pr-12">
              <template v-if="item.answer.blocks">
                <p class="text-sm" :class="[$theme.cardLabelTextColor]">{{ item.answer.blocks[0].data.text }}</p>
              </template>
            </DisclosurePanel>
          </Disclosure>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/vue/24/outline'

export default {
  props: [
    'items'
  ],
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    MinusSmallIcon,
    PlusSmallIcon,
  },
}
</script>